<script setup lang="ts">
  import { computed } from 'vue';
  import { useLocale } from '@tundr/i18n';
  import { visuallyHiddenClass } from '../_shared/styles/visually-hidden.css';
  import { loaderClass } from './Loader.css';
  import { LoaderSize, type LoaderProps } from './Loader.types';

  const props = withDefaults(defineProps<LoaderProps>(), {
    size: LoaderSize.MD,
    announced: true,
  });

  const { t } = useLocale('ds-components');

  const sizesMap: Record<typeof props.size, number> = {
    [LoaderSize.SM]: 22,
    [LoaderSize.MD]: 32,
    [LoaderSize.LG]: 40,
  };

  const dimension = computed(() => sizesMap[props.size]);

  const accessibleLabel = computed(
    () => props.ariaLabel ?? t('loader.aria_label'),
  );
</script>

<template>
  <div
    :id="id"
    :data-testid="testId"
    :class="loaderClass"
    :style="{ width: `${dimension}px`, height: `${dimension}px` }"
    :role="announced ? 'status' : 'img'"
    :aria-label="announced ? undefined : accessibleLabel"
  >
    <span v-if="announced" :class="visuallyHiddenClass">
      {{ accessibleLabel }}
    </span>
  </div>
</template>
